export default __webpack_public_path__ + "static/media/Good.68529b16.svg";